import {useEffect,useRef} from 'react';

// Pointer dismissal uses the menu's outside-press handler. Safari can move
// focus outside before a button's click, so focus alone must not discard it.
export default function useMenuTabExit(open,container,onClose){
  const frame=useRef(null),close=useRef(onClose);close.current=onClose;
  useEffect(()=>()=>cancelAnimationFrame(frame.current),[open]);
  return event=>{
    if(event.key!=='Tab')return;
    cancelAnimationFrame(frame.current);
    frame.current=requestAnimationFrame(()=>{
      if(!container.current?.contains(document.activeElement))close.current();
    });
  };
}
